(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-configurator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lm-cfg]').forEach((root) => {
    const dataEl = document.getElementById('lm-candy-data');
    const candies = dataEl ? JSON.parse(dataEl.textContent) : [];
    const MIN = parseInt(root.dataset.min, 10) || 5;
    const MAX = parseInt(root.dataset.max, 10) || 15;
    const FILTERS = ['Alle', 'Vegan', 'Vegetarisch', 'Sauer', 'Lakritz', 'Glutenfrei', 'HARIBO', 'Trolli', 'Hitschies'];
    const BRANDS = ['HARIBO', 'Trolli', 'Hitschies'];

    const state = { step: 1, container: null, selected: new Set(), filter: 'Alle', query: '', fill: null };

    const $ = (s) => root.querySelector(s);
    const steps = { 1: $('[data-step="1"]'), 2: $('[data-step="2"]'), 3: $('[data-step="3"]') };
    const stepLabel = $('[data-lm-steplabel]');
    const barLabel = $('[data-lm-barlabel]');
    const barPrice = $('[data-lm-barprice]');
    const nextBtn = $('[data-lm-next]');
    const backBtn = $('[data-lm-back]');
    const countEl = $('[data-lm-count]');
    const statusEl = $('[data-lm-status]');
    const progressEl = $('[data-lm-progress]');
    const candyGrid = $('[data-lm-candies]');
    const noResults = $('[data-lm-noresults]');
    const searchEl = $('[data-lm-cfg-search]');
    const filtersEl = $('[data-lm-filters]');
    const cartMsg = $('[data-lm-cart-msg]');
    const esc = (s) => (s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    function containerData() {
      const el = root.querySelector('.lm-cfg__container.is-sel');
      if (!el) return null;
      return { id: el.dataset.id, group: el.dataset.group, label: el.dataset.label, size: el.dataset.size, price: el.dataset.price, fill: el.dataset.fill === '1', variantId: el.dataset.variantId || null };
    }

    // Step 1: container select
    root.querySelectorAll('[data-lm-container]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-lm-container]').forEach((b) => b.classList.remove('is-sel'));
        btn.classList.add('is-sel');
        state.container = btn.dataset.id;
        updateBar();
      });
    });

    // Filters
    filtersEl.innerHTML = FILTERS.map((f) => `<button type="button" class="lm-cfg__chip${f === 'Alle' ? ' is-active' : ''}" data-f="${esc(f)}">${esc(f)}</button>`).join('');
    filtersEl.querySelectorAll('[data-f]').forEach((c) => c.addEventListener('click', () => {
      state.filter = c.dataset.f;
      filtersEl.querySelectorAll('[data-f]').forEach((x) => x.classList.toggle('is-active', x === c));
      renderCandies();
    }));
    searchEl.addEventListener('input', () => { state.query = searchEl.value.trim().toLowerCase(); renderCandies(); });
    $('[data-lm-reset]').addEventListener('click', () => {
      if (state.selected.size === 0) return;
      if (confirm('Auswahl wirklich zurücksetzen?')) { state.selected.clear(); renderCandies(); updateProgress(); updateBar(); }
    });

    function renderCandies() {
      const items = candies.filter((c) => {
        const okFilter = state.filter === 'Alle' || (BRANDS.includes(state.filter) ? c.brand === state.filter : (c.tags || []).includes(state.filter));
        const okQuery = !state.query || c.label.toLowerCase().includes(state.query);
        return okFilter && okQuery;
      });
      candyGrid.innerHTML = items.map((c) => {
        const sel = state.selected.has(c.id);
        const img = c.image ? `<span class="lm-candy__img"><img src="${esc(c.image)}" alt="" loading="lazy"></span>` : '';
        return `<button type="button" class="lm-candy${sel ? ' is-sel' : ''}" data-id="${esc(c.id)}">
          ${img}
          <span class="lm-candy__name">${esc(c.label)}</span>
          <span class="lm-candy__kind">${esc(c.kind)}</span>
          <span class="lm-candy__pick">✓</span>
        </button>`;
      }).join('');
      noResults.hidden = items.length > 0;
      candyGrid.querySelectorAll('[data-id]').forEach((btn) => btn.addEventListener('click', () => toggleCandy(btn.dataset.id)));
    }

    function toggleCandy(id) {
      if (state.selected.has(id)) state.selected.delete(id);
      else { if (state.selected.size >= MAX) return; state.selected.add(id); }
      renderCandies();
      updateProgress();
      updateBar();
    }

    function updateProgress() {
      const n = state.selected.size;
      const valid = n >= MIN;
      countEl.textContent = n;
      statusEl.textContent = valid ? `Noch ${MAX - n} möglich` : `+${MIN - n} nötig`;
      statusEl.style.color = valid ? '#4E9E6A' : 'var(--lm-acc)';
      progressEl.style.width = Math.min(n / MIN, 1) * 100 + '%';
    }

    function shapeSvg(shape, fill) {
      const bands = `<rect x="4" y="84" width="88" height="44" fill="#E9A6BE"/><rect x="4" y="64" width="88" height="22" fill="#F4C99B"/><rect x="4" y="46" width="88" height="20" fill="#A9D5B8"/><rect x="4" y="24" width="88" height="24" fill="#A9C7E0"/>`;
      const dotData = [[34,44,8,'#A9C7E0'],[58,40,7,'#E9A6BE'],[46,58,8,'#F4C99B'],[30,68,7,'#A9D5B8'],[62,64,8,'#A9D5B8'],[48,80,8,'#E9A6BE'],[34,92,7,'#F4C99B'],[63,90,7,'#A9C7E0'],[47,101,7,'#A9C7E0']];
      const dots = dotData.map((d) => `<circle cx="${d[0]}" cy="${d[1]}" r="${d[2]}" fill="${d[3]}"/>`).join('');
      const content = fill === 'layered' ? bands : dots;
      const shapes = {
        bottle: { body: 'M18 24h60v78a10 10 0 0 1-10 10H28a10 10 0 0 1-10-10V24Z', clip: 'M20 26h56v76a8 8 0 0 1-8 8H28a8 8 0 0 1-8-8Z', extras: '<rect x="20" y="6" width="56" height="15" rx="4" fill="#D9CEC4"/>' },
        bucket: { body: 'M13 34H83L77 111a3 3 0 0 1-3 2H19a3 3 0 0 1-3-2L13 34Z', clip: 'M13 34H83L77 111a3 3 0 0 1-3 2H19a3 3 0 0 1-3-2L13 34Z', extras: '<rect x="10" y="27" width="76" height="7" rx="3.5" fill="#D9CEC4"/>' },
      };
      const sh = shapes[shape] || shapes.bottle;
      const cid = 'lmclip-' + shape + '-' + fill;
      return `<svg width="88" height="110" viewBox="0 0 96 120" fill="none"><defs><clipPath id="${cid}"><path d="${sh.clip}"/></clipPath></defs><path d="${sh.body}" fill="#fff" stroke="#DDD3C9" stroke-width="2"/><g clip-path="url(#${cid})">${content}</g>${sh.extras}<path d="${sh.body}" fill="none" stroke="#DDD3C9" stroke-width="2"/></svg>`;
    }

    function renderFillPreviews() {
      const c = containerData();
      const shape = c && c.group === 'Eimer' ? 'bucket' : 'bottle';
      root.querySelector('[data-lm-preview="layered"]').innerHTML = shapeSvg(shape, 'layered');
      root.querySelector('[data-lm-preview="mixed"]').innerHTML = shapeSvg(shape, 'mixed');
    }
    root.querySelectorAll('[data-lm-fill]').forEach((btn) => btn.addEventListener('click', () => {
      state.fill = btn.dataset.lmFill;
      root.querySelectorAll('[data-lm-fill]').forEach((b) => b.classList.toggle('is-sel', b === btn));
      updateBar();
    }));

    function goStep(n) {
      state.step = n;
      Object.entries(steps).forEach(([k, el]) => { el.hidden = parseInt(k, 10) !== n; });
      const labels = { 1: 'Schritt 1 von 3 · Behälter', 2: 'Schritt 2 von 3 · Sorten', 3: 'Schritt 3 von 3 · Befüllung' };
      stepLabel.textContent = labels[n];
      backBtn.hidden = n === 1;
      if (n === 2) renderCandies();
      if (n === 3) renderFillPreviews();
      updateBar();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function updateBar() {
      const c = containerData();
      barLabel.textContent = c ? `${c.label} · ${c.size}` : 'Noch keinen Behälter gewählt';
      barPrice.textContent = c ? c.price : '';
      const n = state.selected.size;
      if (state.step === 1) {
        nextBtn.textContent = 'Sorten wählen';
        nextBtn.disabled = !c;
      } else if (state.step === 2) {
        const last = c && !c.fill;
        nextBtn.textContent = last ? 'In den Warenkorb' : 'Weiter zur Füllung';
        nextBtn.disabled = n < MIN;
      } else {
        nextBtn.textContent = 'In den Warenkorb';
        nextBtn.disabled = false;
      }
    }

    backBtn.addEventListener('click', () => { if (state.step > 1) goStep(state.step - 1); });
    nextBtn.addEventListener('click', () => {
      const c = containerData();
      if (state.step === 1) { if (c) goStep(2); return; }
      if (state.step === 2) {
        if (state.selected.size < MIN) return;
        if (c && !c.fill) return addToCart();
        return goStep(3);
      }
      return addToCart();
    });

    async function addToCart() {
      const c = containerData();
      if (!c) return;
      const names = candies.filter((x) => state.selected.has(x.id)).map((x) => x.label);
      if (!c.variantId) {
        showMsg('Bitte im Theme-Editor ein Produkt für diesen Behälter zuweisen.', true);
        return;
      }
      nextBtn.disabled = true;
      const properties = { 'Behälter': `${c.label} · ${c.size}`, 'Sorten': names.join(', ') };
      if (c.fill && state.fill) properties['Füllung'] = state.fill === 'layered' ? 'Geschichtet' : 'Gemischt';
      try {
        const res = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: c.variantId, quantity: 1, properties }] }),
        });
        if (!res.ok) throw new Error('add failed');
        const cart = await (await fetch(window.routes.cart_url + '.js')).json();
        document.querySelectorAll('[data-lm-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.remove('is-empty'); });
        showMsg('Deine Candys sind im Warenkorb! 🍬');
      } catch (e) {
        showMsg('Ups – das hat nicht geklappt. Bitte erneut versuchen.', true);
        nextBtn.disabled = false;
      }
    }

    let msgTimer;
    function showMsg(text, isError) {
      cartMsg.textContent = text;
      cartMsg.hidden = false;
      cartMsg.style.background = isError ? 'var(--lm-acc)' : '#2E7D52';
      clearTimeout(msgTimer);
      msgTimer = setTimeout(() => { cartMsg.hidden = true; }, 3500);
    }

    updateBar();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-header"]) return;
  try {
    
  document.querySelectorAll('[data-lm-burger]').forEach((btn) => {
    const header = btn.closest('.lm-header');
    const mob = header.querySelector('[data-lm-mob]');
    btn.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      if (mob) mob.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-ingredients"]) return;
  try {
    
  document.querySelectorAll('[data-lm-ing]').forEach((root) => {
    const dataEl = document.getElementById('lm-ing-data');
    if (!dataEl) return;
    const items = JSON.parse(dataEl.textContent);
    const grid = root.querySelector('[data-lm-ing-grid]');
    const countEl = root.querySelector('[data-lm-ing-count]');
    const emptyEl = root.querySelector('[data-lm-ing-empty]');
    const searchEl = root.querySelector('[data-lm-ing-search]');
    const activeTags = new Set();

    const esc = (s) => (s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    function card(it) {
      const tags = (it.tags || []).map((t) => `<span class="lm-ing-card__tag">${esc(t)}</span>`).join('');
      return `<article class="lm-ing-card">
        <h2 class="lm-ing-card__name">${esc(it.name)}</h2>
        <p class="lm-ing-card__meta">${esc(it.brand)} · ${esc(it.kind)} · Nährwerte je 100 g</p>
        ${tags ? `<div class="lm-ing-card__tags">${tags}</div>` : ''}
        <p class="lm-ing-card__ing"><strong>Zutaten:</strong> ${esc(it.ingredients)}</p>
        <div class="lm-ing-card__tiles">
          <div class="lm-ing-card__tile"><div class="lm-ing-card__tile-l">Energie</div><div class="lm-ing-card__tile-v">${esc(String(it.kcal))} kcal</div></div>
          <div class="lm-ing-card__tile"><div class="lm-ing-card__tile-l">Zucker</div><div class="lm-ing-card__tile-v">${esc(it.zucker)}</div></div>
          <div class="lm-ing-card__tile"><div class="lm-ing-card__tile-l">Salz</div><div class="lm-ing-card__tile-v">${esc(it.salz)}</div></div>
        </div>
        <div class="lm-ing-card__allergen"><span><strong>Allergene:</strong> ${esc(it.allergene)}</span></div>
      </article>`;
    }

    function render() {
      const q = (searchEl.value || '').trim().toLowerCase();
      const filtered = items.filter((it) => {
        const hay = (it.name + ' ' + it.brand + ' ' + it.kind + ' ' + it.ingredients).toLowerCase();
        const matchesText = !q || hay.includes(q);
        const matchesTags = activeTags.size === 0 || [...activeTags].every((t) => (it.tags || []).includes(t));
        return matchesText && matchesTags;
      });
      grid.innerHTML = filtered.map(card).join('');
      countEl.textContent = `${filtered.length} von ${items.length} Produkten`;
      emptyEl.hidden = filtered.length > 0;
    }

    searchEl.addEventListener('input', render);
    root.querySelectorAll('[data-lm-ing-tag]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const t = btn.dataset.lmIngTag;
        if (activeTags.has(t)) { activeTags.delete(t); btn.classList.remove('is-active'); }
        else { activeTags.add(t); btn.classList.add('is-active'); }
        render();
      });
    });
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-lm-cart]').forEach((root) => {
    const money = (cents) => {
      try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100); }
      catch { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    };

    // Einwegpfand wird server-gerendert aus item_components summiert (units-korrekt,
    // inkl. Pack-Multiplikator). Das Theme berechnet ihn NICHT neu – bei Mengen-
    // änderungen holt change() den frischen Abschnitt per Section-Rendering-API.
    const sectionId = root.dataset.lmSectionId;

    async function change(key, quantity, row) {
      if (!window.routes?.cart_change_url) return;
      row.classList.add('is-updating');
      try {
        const res = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: sectionId, sections_url: window.location.pathname }),
        });
        const cart = await res.json();
        if (cart.item_count === 0) { window.location.reload(); return; }
        // Header-Badge
        document.querySelectorAll('[data-lm-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.remove('is-empty'); });
        const head = root.querySelector('[data-lm-cart-headcount]');
        if (head) head.textContent = cart.item_count + ' Artikel';
        // Subtotal
        const sub = root.querySelector('[data-lm-subtotal]');
        if (sub) sub.textContent = money(cart.items_subtotal_price);
        // Einwegpfand-Zeile aus dem frisch server-gerenderten Abschnitt übernehmen
        // (units-korrekt aus item_components – keine Neuberechnung im Theme).
        const sectionHtml = cart.sections && sectionId && cart.sections[sectionId];
        if (sectionHtml) {
          const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const freshRow = doc.querySelector('[data-lm-pfand-row]');
          const freshAmt = doc.querySelector('[data-lm-pfand-amount]');
          const pRow = root.querySelector('[data-lm-pfand-row]');
          const pAmt = root.querySelector('[data-lm-pfand-amount]');
          if (pAmt && freshAmt) pAmt.textContent = freshAmt.textContent.trim();
          if (pRow && freshRow) pRow.hidden = freshRow.hasAttribute('hidden');
        }
        // Zeile aktualisieren oder entfernen
        const item = cart.items.find((i) => i.key === key);
        if (!item || quantity === 0) { row.remove(); }
        else {
          row.querySelector('[data-lm-qty-input]').value = item.quantity;
          row.querySelector('[data-lm-line-price]').textContent = money(item.final_line_price);
          row.classList.remove('is-updating');
        }
      } catch (e) { row.classList.remove('is-updating'); }
    }

    root.querySelectorAll('[data-lm-line]').forEach((row) => {
      const key = row.dataset.key;
      const input = row.querySelector('[data-lm-qty-input]');
      // Zeilen ohne Mengen-Input (z. B. die Pflicht-Pfandzeile) überspringen.
      if (!input) return;
      row.querySelectorAll('[data-lm-qty]').forEach((btn) => btn.addEventListener('click', () => {
        const q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.lmQty, 10));
        change(key, q, row);
      }));
      input.addEventListener('change', () => change(key, Math.max(0, parseInt(input.value, 10) || 0), row));
      const rm = row.querySelector('[data-lm-remove]');
      if (rm) rm.addEventListener('click', () => change(key, 0, row));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-lm-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-main-product"]) return;
  try {
    
  document.querySelectorAll('[data-lm-pdp]').forEach((root) => {
    // Gallery thumbs
    const stageImg = root.querySelector('[data-lm-stage] .lm-pdp__img');
    root.querySelectorAll('[data-lm-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (stageImg) stageImg.src = btn.dataset.lmThumb;
        root.querySelectorAll('[data-lm-thumb]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    // Quantity
    const qtyInput = root.querySelector('[data-lm-qty-input]');
    root.querySelectorAll('[data-lm-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.lmQty, 10);
        const val = Math.min(99, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step));
        qtyInput.value = val;
      });
    });

    // Variants
    const variantsEl = root.querySelector('[data-lm-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const idInput = root.querySelector('[data-lm-variant-id]');
    const priceValue = root.querySelector('[data-lm-price-value]');
    const compareEl = root.querySelector('[data-lm-compare]');
    const stock = root.querySelector('[data-lm-stock]');
    const stockLabel = root.querySelector('[data-lm-stock-label]');
    const addBtn = root.querySelector('[data-lm-add]');
    const addLabel = root.querySelector('[data-lm-add-label]');
    const groups = [...root.querySelectorAll('[data-lm-option]')];
    const pfandEl = root.querySelector('[data-lm-pfand]');
    let pfandCentsPerUnit = 0;      // Einwegpfand je Getränk in Cent (0 = kein Pfand)
    const pfandUnitsByVariant = {}; // Varianten-ID → Pack-Einheiten
    const LOW = parseInt((stock && stock.dataset.lmLow) || '10', 10);

    const money = (cents) => {
      try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100); }
      catch { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    };

    function updateVariant() {
      if (!variants.length || !groups.length) return;
      const chosen = groups.map((g) => {
        const active = g.querySelector('.lm-pdp__swatch.is-active') || g.querySelector('.lm-pdp__swatch');
        return active ? active.dataset.lmValue : '';
      });
      const v = variants.find((vr) => chosen.every((val, i) => vr.options[i] === val));
      if (!v) return;
      idInput.value = v.id;
      if (priceValue) priceValue.textContent = money(v.price);
      if (compareEl) compareEl.style.display = v.compare_at_price > v.price ? '' : 'none';
      if (v.available) {
        addBtn.disabled = false; if (addLabel) addLabel.textContent = 'In den Warenkorb';
        if (stock) stock.classList.remove('is-sold');
        const low = v.inventory_management === 'shopify' && v.inventory_policy !== 'continue' && v.inventory_quantity > 0 && v.inventory_quantity <= LOW;
        if (stock) stock.classList.toggle('is-low', low);
        if (stockLabel) stockLabel.textContent = low ? ('Nur noch ' + v.inventory_quantity + ' auf Lager') : 'Auf Lager';
      } else {
        addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Ausverkauft';
        if (stock) { stock.classList.add('is-sold'); stock.classList.remove('is-low'); }
        if (stockLabel) stockLabel.textContent = 'Ausverkauft';
      }
      renderPfand();
    }
    groups.forEach((g) => {
      g.querySelectorAll('.lm-pdp__swatch').forEach((btn) => {
        btn.addEventListener('click', () => {
          g.querySelectorAll('.lm-pdp__swatch').forEach((b) => {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          updateVariant();
        });
      });
    });

    // Einwegpfand-Ausweisung füllen: Betrag × Pack-Einheiten der gewählten
    // Variante. Daten vom App-Proxy (gleiche Quelle wie Warenkorb/Function),
    // da die $app-Metafelder im Theme nicht lesbar sind.
    function renderPfand() {
      if (!pfandEl || !pfandCentsPerUnit) return;
      const vid = idInput ? String(idInput.value) : '';
      const units = pfandUnitsByVariant[vid] || 1;
      pfandEl.textContent = 'zzgl. ' + money(pfandCentsPerUnit * units) + ' Einwegpfand';
      pfandEl.hidden = false;
    }
    if (pfandEl) {
      const pid = pfandEl.dataset.lmProductId;
      fetch('/apps/candy/config', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          const pf = (d && d.pfand) || {};
          const prod = (pf.products || []).find((p) => String(p.productId) === String(pid));
          if (!prod) return; // kein Pfand für dieses Produkt → Hinweis bleibt versteckt
          pfandCentsPerUnit = Math.round((prod.amount || 0) * 100);
          (pf.units || []).forEach((u) => {
            if (u && u.variantId != null) pfandUnitsByVariant[String(u.variantId)] = u.units || 1;
          });
          renderPfand();
        })
        .catch(() => {});
    }

    // AJAX add to cart
    const form = root.querySelector('#lm-product-form');
    if (form) {
      form.addEventListener('submit', async (e) => {
        if (!window.routes?.cart_add_url) return; // fallback: normaler Submit
        e.preventDefault();
        addBtn.disabled = true;
        try {
          const res = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput.value, 10) || 1 }),
          });
          if (!res.ok) throw new Error('add failed');
          const cart = await (await fetch(window.routes.cart_url + '.js')).json();
          document.querySelectorAll('[data-lm-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.remove('is-empty'); });
          addBtn.classList.add('is-added'); if (addLabel) addLabel.textContent = '✓ Im Warenkorb';
          setTimeout(() => { addBtn.classList.remove('is-added'); if (addLabel) addLabel.textContent = 'In den Warenkorb'; addBtn.disabled = false; }, 2000);
        } catch (err) { form.submit(); }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-main-search"]) return;
  try {
    
  document.querySelectorAll('[data-lm-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlideshow(root) {
      if (root.dataset.lmReady === '1') return;
      root.dataset.lmReady = '1';
      var track = root.querySelector('[data-lm-ss-track]');
      var dotsWrap = root.querySelector('[data-lm-ss-dots]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      if (!track || slides.length < 2) return;

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (s, i) {
          var b = document.createElement('button');
          b.className = 'lm-ss__dot' + (i === 0 ? ' is-active' : '');
          b.type = 'button';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      var current = 0;
      function setActive(i) {
        current = i;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        });
      });

      if (root.dataset.autoplay === 'true') {
        var ms = parseInt(root.dataset.interval, 10) || 6000;
        var timer = setInterval(function () {
          var next = (current + 1) % slides.length;
          track.scrollTo({ left: track.clientWidth * next, behavior: 'smooth' });
        }, ms);
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
      }
    }
    function init() { document.querySelectorAll('[data-lm-ss]').forEach(initSlideshow); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-widerrufsrecht"]) return;
  try {
    
  document.querySelectorAll('[data-lm-print]').forEach((btn) => {
    btn.addEventListener('click', () => window.print());
  });

  } catch(e) { console.error(e); }
})();
})();
